import React from "react";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  Paper,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import { CardActions } from "@mui/material";
import GradeIcon from "@mui/icons-material/Star";


export default function CateringCards() {

    const data = [
        {
          id: "1",
          description: "Buffet Menu Package",
          image: "./images/Rectangle 8.png",
          rating: "4.7",
          price: "50",
        },
        {
            id: "1",
            description: "Buffet Menu Package",
            image: "./images/Rectangle 8.png",
            rating: "4.7",
            price: "50",
          },
          {
            id: "1",
            description: "Buffet Menu Package",
            image: "./images/Rectangle 8.png",
            rating: "4.7",
            price: "50",
          },
        
      ];



  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems:'center'
          }}
        >
          <Box>
            <Typography sx={{fontSize: {xl: "40px", lg: "40px", md: "40px", sm:  "40px", xs: "30px"}, fontWeight: "600", lineHeight: "56px", pb: {xl: "40px", lg: "10px", md: "10px", sm: "10px", xs: "10px"}}}>Top Catering Package</Typography>
          </Box>

          <Box>
            <Typography color= "#2B817B" sx={{fontSize: {xl: "20px" ,lg: "16px", md: "16px", sm: "14px", xs: "14px"}, fontWeight: "400", lineHeight: "24px", color: "#2B817B" }}>See All Catering Package</Typography>
          </Box>
        </Box>


        <Box>
        <Grid container spacing={4} sx={{
                  display:'flex',
                  flexDirection:'row',
                  justifyContent:'center'
                }}>
          {data.map((v, i) => {
            return (
              <>
                <Grid item xl={3.5} lg={4} md={4} sm={6} xs={12} >
                  <Card
                    sx={{
                      // maxWidth: "416px",
                      width: {xl: "auto", lg: "auto", sm: "100%", xs: "100%"},
                      paddingBottom: {lg: "12px", md: "30px", sm: "16px", xs: "20px"},
                      borderRadius: "8px",
                      borderColor: "#E1E1E6",
                      backgroundColor: "#FFFFFF",
                      // height: "330px",
                      height: {xl: "600px", lg: "350px", md: "330px", sm: "330px", xs: "330px"},

                    }}
                  >
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        // height="266.25px"
                        width="416px"
                        image={v.image}
                        alt="green iguana"
                        sx={{height: {xl: "450px", lg: "276.25px", md: "276.25px", sm: "250px", xs: "266.25px"}}}
                      />
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            // marginLeft: "12px",
                            justifyContent: "space-between"
                          }}
                        >
                          
                          <Box>
                          <Typography
                          gutterBottom
                          variant="h5"
                          component="div"
                          fontWeight="500"                          
                          lineHeight="26px"
                          
                          sx={{fontSize: {xl: "18px",lg: "18px", md: "18px", sm: "16px", xs: "16px"}, width:{xl: "auto", lg: "261px", md: "261px", sm: "261px", xs: "261px"}, pt: {xl: "20px", lg: "0px", md: "0px", sm: "0px", xs: "0px"}}}
                          // height="52px"
                        >
                          {v.description}
                        </Typography>
                          </Box>

                          <Box sx={{ display: "flex", flexDirection: "row" }}>
                            {/* <img
                              src="./images/Star.svg"
                              alt=""
                              width={"13px"}
                              height={"12.45px"}
                            /> */}
                            <Box sx={{color: "#FAA641",}}>
                            <GradeIcon  sx={{width: {xl: "18px", lg: "12px", md: "12px", sm: "12px", xs: "12px"},
                                    height: {xl: "50px", lg: "12.45px", md: "12.45px", sm: "12.45px", xs: "12.45px"}}} />
                                    
                            </Box>
                            <Typography
                              sx={{
                                // width: "16px",
                                // height: "16px",
                                fontSize:{xl: "18px", lg: "14px", md: "14px", sm: "14px", xs:"14px"},
                                fontWeight: "600",
                                lineHeight: "16px",
                                paddingLeft: "9.5px",
                                color: "#FAA641",
                                pt: {xl: "16px", lg: "0px"},
                              }}
                            >
                              {v.rating}
                            </Typography>
                          </Box>
                        </Box>
                        

                        <Box sx={{ display: "flex", flexDirection: "row" }}>
                          <Typography
                            variant="body2"
                            color="#545359"
                            sx={{
                              // width: "200px",
                              // height: "20px",
                              fontSize: {xl: "15px", lg: "14px", md: "14px", sm: "14px", xs:"14px"},
                              fontWeight: "400",

                            }}
                          >
                            Starting from ${v.price} / (pax)
                          </Typography>
                        </Box>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              </>
            );
          })}
        </Grid>
        </Box>
      </Box>
    </>
  );
}
